<section class="container">
    <app-form-generator
        *ngIf="!!formGeneratorInput"
        [formGeneratorInput]="formGeneratorInput"
        (formGroupRef)="formGroup = $event"
    ></app-form-generator>
</section>
